// App - main application component with routing
// Implements US-1.2: Join Room flow and US-1.4: Create Room UI

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import JoinRoom from './pages/JoinRoom';
import CreateRoom from './pages/CreateRoom';
import RoomBoard from './pages/RoomBoard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public landing page for participants */}
            <Route path="/" element={<JoinRoom />} />
            <Route path="/join" element={<JoinRoom />} />
            <Route path="/join/:code" element={<JoinRoom />} />

            {/* Facilitator room creation (requires authentication) */}
            <Route
              path="/create"
              element={
                <ProtectedRoute>
                  <CreateRoom />
                </ProtectedRoute>
              }
            />

            {/* Room board view (accessible to facilitators and participants) */}
            <Route path="/room/:roomId" element={<RoomBoard />} />

            {/* Redirect unknown routes to join page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
